var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticClass: "img-fluid mb-4 rounded",
        attrs: { src: "/media/header/series.jpg", alt: "Series" }
      }),
      _vm._v(" "),
      _c("static-loading-indicator-icon"),
      _vm._v(" "),
      !_vm.$store.getters.shouldLoadLocal
        ? _c("div", [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.seriesList, function(series) {
                return _c(
                  "div",
                  { staticClass: "col-xl-6 mb-4" },
                  [_c("series-card", { attrs: { series: series } })],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c("pagination", {
                  attrs: { data: _vm.paginationData },
                  on: { "pagination-change-page": _vm.getSeries }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }